module.exports = __webpack_public_path__ + "static/media/RoboSub.9d6eb97e.jpg";